import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { Tier } from '@foundry/shared';
import { apiFetch } from './client.js';
import type { Membership } from './types.js';

export function useMembership() {
  return useQuery({
    queryKey: ['membership'],
    queryFn: () => apiFetch<{ membership: Membership }>('/membership').then((r) => r.membership),
  });
}

/** Schedule an upgrade/downgrade for the next period (or clear it via the current tier). */
export function useChangeTier() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (tier: Tier) =>
      apiFetch<{ membership: Membership }>('/membership/change', {
        method: 'POST',
        body: { tier },
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['membership'] }),
  });
}

export function useCancelMembership() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () =>
      apiFetch<{ membership: Membership }>('/membership/cancel', { method: 'POST' }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['membership'] }),
  });
}

/** Undo a pending change or cancellation, keeping the current plan. */
export function useResumeMembership() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () =>
      apiFetch<{ membership: Membership }>('/membership/resume', { method: 'POST' }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['membership'] }),
  });
}
